import { Injectable } from '@angular/core';
import { CommunicationManagerService } from './communication-manager.service';
import { RegistryEntity } from '../models/registry-entity.model';

@Injectable({
  providedIn: 'root',
})
export class EntityService {
  constructor(private cm: CommunicationManagerService) {}

  public getAllRegistryEntities(companyId: string) {
    return this.cm.get(`registryEntity/all`, [
      { headerName: 'companyId', headerValue: companyId },
    ]);
  }

  public getRegitryEntitiesByType(type: string, companyId: string) {
    return this.cm.get(`registryEntity/all/${type}`, [
      { headerName: 'companyId', headerValue: companyId },
    ]);
  }

  public getRegistryEntity(guid: string, companyId: string) {
    return this.cm.get(`registryEntity/${guid}`, [
      { headerName: 'companyId', headerValue: companyId },
    ]);
  }

  public saveRegistryEntity(entity: RegistryEntity) {
    //see if mapping should be moved to backend, to send whole objects and ignore any extra  fields that are sent
    const payload = {
      name: entity.name,
      type: entity.type,
      domains: [entity?.domains?.[0]?.toLowerCase() ?? ''],
      role: entity.role,
      place: entity.place,
      avgFee: entity.avgFee,
      note: entity.note,
      portfolio: entity.portfolio,
      email: entity.email,
      address: entity.address,
      phone: entity.phone,
      links: entity.links,
      agencies: entity.agencies,
      company: entity.company,
    };

    return this.cm.post(`registryEntity`, payload, [
      { headerName: 'companyId', headerValue: entity.company },
    ]);
  }

  public updateRegistryEntity(entity: RegistryEntity) {
    const payload = {
      name: entity.name,
      type: entity.type,
      domains: ['other'],
      role: entity.role,
      place: entity.place,
      avgFee: entity.avgFee,
      note: entity.note,
      portfolio: entity.portfolio,
      email: entity.email,
      address: entity.address,
      phone: entity.phone,
      links: entity.links,
      agencies: entity.agencies,
      // company: entity.company,
    };
    //console.log(payload);
    return this.cm.put(`registryEntity/${entity._id}`, payload, [
      { headerName: 'companyId', headerValue: entity.company },
    ]);
  }
}
